import { Box, Card, Skeleton, Title, Text } from '@nimbus-ds/components';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';

export function TrackingPageMessageCardSkeleton() {
  const t = useTranslationConfigurations(
    'settingsCheckout.settingsCheckoutForm.trackingPageMessageCard',
  );

  return (
    <Card>
      <Card.Header>
        <Box display="flex" flexDirection="row" justifyContent="space-between">
          <Box display="flex" flexDirection="column" gap="2">
            <Title fontSize="h2">{t('title')}</Title>
            <Text>{t('subTitle')}</Text>
          </Box>
          <Skeleton height="1.25em" width="45px" borderRadius="1em" />
        </Box>
      </Card.Header>

      <Card.Body>
        <Box display="flex" flexDirection="column" gap="4">
          <Skeleton height="1rem" width="300px" />
          <Skeleton height="2rem" width="200px" />
        </Box>
      </Card.Body>
    </Card>
  );
}
